export default {
  name: 'Názov',
  durationInMins: 'Dlžka trvania v minútach',
  createProduct: 'Vytvoriť produkt'
}



// WEBPACK FOOTER //
// ./src/i18n/sk/routes/product.js